import { createGlobalStyle } from 'styled-components';

/** Base colors that's defined with explicit color values */
const BASE_COLORS = {
  'green-1': '#3bca96',
  'green-2': '#26a69a',
  'green-3': '#24ce88',
  'green-4': '#72bf63',
  'green-5': 'rgba(114, 191, 99, 0.8)',
  'green-6': 'rgba(59, 202, 150, 0.87)',
  'green-7': '#7ac142',
  'green-8': '#66ab59',
  'blue-1': '#088482',
  'blue-2': '#2580bc',
  'blue-3': '#2980bb',
  'blue-4': 'rgba(143, 215, 251, 0.3)',
  'blue-5': 'rgba(0, 136, 204, 0.8)',
  'blue-6': 'rgba(66, 154, 213, 0.8)',
  'blue-7': 'rgba(37, 128, 188, 0.9)',
  'blue-8': 'rgba(37, 128, 188, 0.5)',
  'blue-9': 'rgba(37, 128, 188, 0.15)',
  'blue-10': 'rgba(0, 136, 204, 0.5)',
  'blue-11': '#c5ebff',
  'blue-12': '#0088cc',
  'blue-13': 'rgba(0, 136, 204, 0.3)',
  'orange-1': '#ffa000',
  'orange-2': '#ffc768',
  'orange-3': 'rgba(255, 160, 0, 0.8)',
  'orange-4': 'rgba(255, 179, 51, 0.8)',
  'orange-5': 'rgba(255, 179, 51, 0.5)',
  'orange-6': '#ffc562',
  'purple-1': '#4527a0',
  'red-1': '#f54',
  'red-2': 'rgba(188, 0, 2, 0.87)',
  'red-3': 'rgba(255, 85, 68, 0.8)',
  'dark-1': 'rgba(0, 0, 0, 0.8)',
  'dark-2': '#333',
  'dark-3': '#555',
  white: '#fff',
  blueWhale: '#042741',
  catskillWhite: '#eef2f6',
  horizon: '#6089a8',

  // TURQUOISE
  'color-turquoise-lighter': '#e6fcfc',
  'color-turquoise-light': '#a9f6f5',
  'color-turquoise': '#0dbebb',
  'color-turquoise-medium': '#5de8e5',
  'turquoise-dark-rgb': '8, 132, 130',
  'color-turquoise-dark': 'rgb(8, 132, 130)',
  'color-turquoise-darker': '#081e1c',

  // GREEN
  'color-green-lighter': '#dbfcdb',
  'color-green-light': '#8fd88f',
  'color-green': '#34993c',
  'green-dark-rgb': '35, 116, 56',
  'color-green-dark': 'rgb(35, 116, 56)',
  'color-green-darker': '#002300',

  // YELLOW
  'yellow-lighter-rgb': '249, 233, 183',
  'color-yellow-lighter': 'rgb(249, 233, 183)',
  'color-yellow-light': '#ffd671',
  'color-yellow': '#f9c327',
  'color-yellow-dark': '#b8921a',
  'color-yellow-darker': '#3e3100',

  // ORANGE
  'color-orange-lighter': '#ffd6bb',
  'color-orange-light': '#fc9f60',
  'color-orange': '#ed6b00',
  'orange-dark-rgb': '175, 80, 22',
  'color-orange-dark': 'rgb(175, 80, 22)',
  'color-orange-darker': '#38180c',

  // RETRO ORANGE
  'color-retro-orange-light': '#ffd080',
  'color-retro-orange': '#ffa000',
  'color-retro-orange-dark': '#cc8000',

  // RED
  'color-red-lighter': '#fbe6e6',
  'color-red-light': '#f19794',
  'color-red-medium-light': '#df3020',
  'red-rgb': '202, 43, 29',
  'color-red': 'rgb(202, 43, 29)',
  'color-red-dark': '#a02015',
  'color-red-darker': '#410704',
  'color-red-darkest': '#694542',

  // PURPLE
  'color-purple-lighter': '#ebdefc',
  'color-purple-light': '#c285f9',
  'color-purple': '#8724b5',
  'color-purple-dark': '#542368',
  'color-purple-darker': '#170021',

  // BLUE
  'color-blue-lighter': '#bbd4ef',
  'color-blue-light': '#668bcc',
  'color-blue': '#24418b',
  'color-blue-dark': '#132760',
  'color-blue-darker': '#00002f',

  // RETRO BLUE
  'color-retro-blue-light': '#6bd1df',
  'retro-blue-rgb': '41, 128, 187',
  'color-retro-blue': 'rgb(41, 128, 187)',
  'color-motion': '41, 128, 187',
  'color-retro-blue-dark': '#206592',

  // LIGHT GRAY
  'color-light-gray-lightest': '#f4f4f4',
  'color-light-gray-lighter': '#eaeaea',
  'light-gray-light-rgb': '226, 226, 226',
  'color-light-gray-light': 'rgb(226, 226, 226)',
  'color-light-gray': '#cecece',
  'light-gray-dark-rgb': '191, 191, 191',
  'color-light-gray-dark': 'rgb(191, 191, 191)',
  'color-light-gray-darker': '#b2b2b2',
  'color-light-gray-darkest': '#a0a0a0',

  // DARK GRAY
  'dark-gray-lightest-rgb': '153, 153, 153',
  'color-dark-gray-lightest': 'rgb(153, 153, 153)',
  'color-dark-gray-lighter': '#878787',
  'dark-gray-light-rgb': '93, 93, 93',
  'color-dark-gray-light': 'rgb(93, 93, 93)',
  'color-dark-gray': '#3f3f3f',
  'color-dark-gray-dark': '#2d2d2d',
  'dark-gray-darker-rgb': '30, 30, 30',
  'color-dark-gray-darker': 'rgb(30, 30, 30)',
  'color-dark-gray-darkest': '#0f0f0f',

  // BLACK / WHITE / TRANSPARENT
  'black-rgb': '0, 0, 0',
  'color-black': 'rgb(0, 0, 0)',
  'white-rgb': '255, 255, 255',
  'color-white': 'rgb(255, 255, 255)',
  'color-white-unselected': '#f1f1f1',
  'color-transparent': 'transparent',

  // MISC GREYS
  'silver-chalice': '#aaa',
  'wild-sand': '#f5f5f5',
  'mine-shaft': '#333',
};

/** Abstrcted common colors that applies to the whole application
 * and can be reused to define other colors */
const MAIN_ABSTRACTED_COLORS = {
  'color-primary-dark': '#045e5e',
  'color-primary': BASE_COLORS['color-turquoise-dark'],
  'color-primary-light': BASE_COLORS['color-turquoise'],
  'color-secondary': BASE_COLORS['color-blue'],
  'color-secondary-light': BASE_COLORS['color-blue-light'],

  // EVENT COLORS
  'transaction-color': BASE_COLORS['green-4'],
  'motion-color': BASE_COLORS['blue-3'],
  'bookmark-color': BASE_COLORS['orange-1'],
};

/** All colors that can be accessed in the app globally */
export const GLOBAL_COLORS = {
  ...BASE_COLORS,
  ...MAIN_ABSTRACTED_COLORS,

  // TEXT
  'color-text': BASE_COLORS['color-dark-gray-darkest'],

  // STATE COLOURS
  'color-success': BASE_COLORS['color-green-dark'],
  'color-success-text': BASE_COLORS['color-white'],
  'color-warning': BASE_COLORS['color-yellow'],
  'color-warning-text': BASE_COLORS['color-yellow-darker'],
  'color-error': BASE_COLORS['color-red-dark'],
  'color-error-text': BASE_COLORS['color-white'],

  // MISC COLORS
  'color-app-bar': '#3f3f3f',
  'color-modal-dark-info-box': '#666666',
  'color-modal-dark-info-box-error': '#fccbca',
  'color-modal-dark-inner-section': '#444444',
  'color-modal-overlay': 'rgba(0, 0, 0, 0.5)',
  'color-player-yellow': '#fcb130',
  'color-solink-logo-arc': '#00404c',
  'color-app-bar-active': BASE_COLORS['color-turquoise'],
  'color-solink-internal-highlight': BASE_COLORS['color-turquoise'],
  'color-solink-internal-highlight-light': BASE_COLORS['color-turquoise-light'],
  'color-solink-internal-highlight-lighter': BASE_COLORS['color-turquoise-lighter'],

  'camera-card-highlight-background': '#505050',
  'alarm-red': '#df3020',
  textColor: BASE_COLORS['color-dark-gray-lighter'],
  lightGrayHighlight: BASE_COLORS['color-light-gray-lightest'],
  fieldBorderColor: BASE_COLORS['color-light-gray'],
  fieldErrorShadow: '0 0 0 1px inset ' + BASE_COLORS['color-red-dark'],
  fieldFocusShadow: '0 0 0 1px inset ' + BASE_COLORS['color-turquoise-dark'], // color-primary
  fieldLabelColor: BASE_COLORS['color-dark-gray-light'],
  fieldDisabledBG: BASE_COLORS['color-light-gray-lighter'],
  containerBackground: BASE_COLORS['color-white'],

  // ALARM COLORS
  'color-alarm-disarm': BASE_COLORS['color-green'],
  'color-alarm-arm': BASE_COLORS['color-orange'],

  // NAVIGATION PANEL
  'nav-color': BASE_COLORS['blue-2'],
  'company-logo-button': BASE_COLORS['orange-1'],

  // LOCATION SELECTOR
  'location-item-selected-bg': BASE_COLORS['orange-1'],

  // SHARE
  'share-bg': BASE_COLORS['green-1'],

  // VIDEO PLAYER
  'mini-cam-selector-active-bg': BASE_COLORS['orange-5'],

  // LOGIN PAGE
  'login-background-solid': BASE_COLORS['blue-2'],
  'login-background-semi': BASE_COLORS['blue-7'],
  'login-loading-spin-color': BASE_COLORS['blue-1'],
  'login-button-bg': BASE_COLORS['orange-1'],
  'login-button-txt': BASE_COLORS['white'],
  'forgot-button-bg': BASE_COLORS['orange-1'],
  'forgot-button-txt': BASE_COLORS['white'],

  // EVENTS PAGE
  // HISTOGRAM
  'motion-area': BASE_COLORS['blue-4'],
  'transaction-bar': BASE_COLORS['green-4'],
  'bookmark-bar': BASE_COLORS['orange-2'],
  cursor: BASE_COLORS['red-1'],

  // FILTER
  'filter-item-bg': BASE_COLORS['orange-1'],
  'filter-item-delete': BASE_COLORS['orange-1'],
  'search-highlight-color': BASE_COLORS['orange-1'],
  'search-submit-bg': BASE_COLORS['blue-5'],
  'search-submit-txt': BASE_COLORS['white'],
  'search-changes-highlight': BASE_COLORS['orange-1'],
  'search-revert-bg': BASE_COLORS['orange-1'],
  'search-revert-txt': BASE_COLORS['white'],

  'filter-toggle-transaction': BASE_COLORS['green-5'],
  'filter-toggle-motion': BASE_COLORS['blue-6'],
  'filter-toggle-bookmark': BASE_COLORS['orange-4'],
  'filter-toggle-starred': BASE_COLORS['dark-3'],
  'filter-toggle-starred-active-txt': BASE_COLORS['orange-4'],

  'report-create-bg': BASE_COLORS['green-5'],
  'report-create-notification-bg': BASE_COLORS['blue-2'],

  // EVENT GRID
  'investigate-tooltip-bg': BASE_COLORS['green-1'],

  // VIDEO PAGE
  'time-input-color': BASE_COLORS['orange-1'],

  // CAMERA GRID
  'tooltip-black-bg': BASE_COLORS['dark-1'],
  'tooltip-blue-bg': BASE_COLORS['blue-1'],
  'tooltip-primary-bg': BASE_COLORS['green-1'],
  'tooltip-secondary-bg': BASE_COLORS['dark-2'],

  // SETTINGS PAGE
  'banner-bg': BASE_COLORS['orange-1'],
  'about-h1': BASE_COLORS['blue-2'],
  'about-h2': BASE_COLORS['blue-2'],

  'location-assign-all-button': BASE_COLORS['orange-1'],

  'search-color': BASE_COLORS['color-yellow'],
  'alarm-color': BASE_COLORS['color-red-medium-light'],

  motionBarsColor: BASE_COLORS['color-blue-light'],
  motionAiPersonColor: BASE_COLORS['color-orange-light'],
  motionAiVehicleColor: BASE_COLORS['color-turquoise-medium'],
  estimatedColor: BASE_COLORS['color-turquoise-medium'],
  downloadExpiredColor: BASE_COLORS['color-light-gray-darkest'],
  scheduledActivityInvalidColor: BASE_COLORS['color-light-gray-darkest'],

  bookmarkColor: MAIN_ABSTRACTED_COLORS['bookmark-color'],
  motionColor: MAIN_ABSTRACTED_COLORS['motion-color'],
  transactionColor: MAIN_ABSTRACTED_COLORS['transaction-color'],

  pageBackground: BASE_COLORS['color-dark-gray-darker'],
  foreground: BASE_COLORS['color-white'],
  contentBackground: BASE_COLORS['color-dark-gray-dark'],
  headerBackground: BASE_COLORS['color-dark-gray'],
  inputBackground: BASE_COLORS['color-dark-gray'],
  selected: BASE_COLORS['color-dark-gray-light'],
};

function createCSSVariables(colors: Record<string, string>) {
  return Object.entries(colors)
    .map(([key, value]) => `--${key}: ${value};`)
    .join('\n');
}

export const GlobalStyle = createGlobalStyle`
  :root {
    ${createCSSVariables(GLOBAL_COLORS)}
  }
`;
